var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"element-loading-text":"加载中"}},[_c('div',{staticClass:"index_box"},[_c('img',{attrs:{"src":require("@/assets/imgs3.jpg")}})])])
}]

export { render, staticRenderFns }